/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
import '../common/workflow/ui_elements/common';
import '../common/workflow/ui_elements/ui_element';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "GetBillPayDataRequest": {
                    "fields": {
                      "authorizationCode": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "unitToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetBillPayDataResponse": {
                    "fields": {
                      "value": {
                        "type": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData",
                        "id": 1
                      },
                      "error": {
                        "type": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse.Error",
                        "id": 2
                      }
                    },
                    "nested": {
                      "BillPayData": {
                        "fields": {
                          "card": {
                            "type": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData.PrivateCardData",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "directDepositAccount": {
                            "type": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData.PrivateDirectDepositAccountData",
                            "id": 2,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "PrivateCardData": {
                            "fields": {
                              "fullPan": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "cvc": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "expiration": {
                                "type": ".squareup.common.time.YearMonth",
                                "id": 3,
                                "rule": "optional"
                              },
                              "nameOnCard": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          },
                          "PrivateDirectDepositAccountData": {
                            "fields": {
                              "routingNumber": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "accountNumber": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "Error": {
                        "values": {
                          "UNKNOWN": 0,
                          "UNAUTHORIZED": 1,
                          "AUTHORIZATION_FAILURE": 2
                        }
                      },
                      "result": {
                        "oneof": ["value", "error"]
                      }
                    }
                  },
                  "GetBillPayDataConfigurationResponse": {
                    "fields": {
                      "twoFactorConfirmation": {
                        "type": ".squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.TwoFactorConfirmation",
                        "id": 1
                      },
                      "billPayDataConfiguration": {
                        "type": ".squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration",
                        "id": 2
                      },
                      "error": {
                        "type": ".squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.Error",
                        "id": 3
                      }
                    },
                    "nested": {
                      "TwoFactorConfirmation": {
                        "fields": {
                          "header": {
                            "type": ".squareup.bbfrontend.service.v1.ScreenHeader",
                            "id": 1,
                            "rule": "optional"
                          },
                          "codeInput": {
                            "type": ".squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.TwoFactorConfirmation.CodeInput",
                            "id": 2,
                            "rule": "optional"
                          },
                          "continueButtonText": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "resendCodeText": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "CodeInput": {
                            "fields": {
                              "label": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "codeLength": {
                                "type": "int32",
                                "id": 2,
                                "rule": "optional"
                              },
                              "placeholder": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "errorMessage": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "BillPayDataConfiguration": {
                        "fields": {
                          "header": {
                            "type": ".squareup.bbfrontend.service.v1.ScreenHeader",
                            "id": 1,
                            "rule": "optional"
                          },
                          "copyButtonText": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "cardsSection": {
                            "type": ".squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration.CardsSection",
                            "id": 3,
                            "rule": "optional"
                          },
                          "accountsSection": {
                            "type": ".squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection",
                            "id": 4,
                            "rule": "optional"
                          },
                          "viewLogEvent": {
                            "type": ".squareup.bbfrontend.service.v1.LogEvent",
                            "id": 5,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "CardsSection": {
                            "fields": {
                              "title": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "recommendedLabel": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "cardOptions": {
                                "type": ".squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration.CardsSection.CardOption",
                                "id": 3,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "CardOption": {
                                "fields": {
                                  "id": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "name": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "card": {
                                    "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          },
                          "AccountsSection": {
                            "fields": {
                              "title": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "accounts": {
                                "type": ".squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.Account",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "logEvents": {
                                "type": ".squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.AccountsSectionLogEvents",
                                "id": 3,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "Account": {
                                "fields": {
                                  "id": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "name": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "values": {
                                    "type": ".squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.Account.Value",
                                    "id": 3,
                                    "rule": "repeated"
                                  }
                                },
                                "nested": {
                                  "Value": {
                                    "fields": {
                                      "label": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "number": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "copyLogEvent": {
                                        "type": ".squareup.bbfrontend.service.v1.LogEvent",
                                        "id": 5,
                                        "rule": "optional"
                                      }
                                    }
                                  }
                                }
                              },
                              "AccountsSectionLogEvents": {
                                "fields": {
                                  "expandLogEvent": {
                                    "type": ".squareup.bbfrontend.service.v1.LogEvent",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "collapseLogEvent": {
                                    "type": ".squareup.bbfrontend.service.v1.LogEvent",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          }
                        }
                      },
                      "Error": {
                        "fields": {
                          "title": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "subtitle": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "buttonText": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "result": {
                        "oneof": ["twoFactorConfirmation", "billPayDataConfiguration", "error"]
                      }
                    }
                  },
                  "BillPayAvailabilityRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "BillPayAvailabilityResponse": {
                    "fields": {
                      "access": {
                        "type": ".squareup.bbfrontend.service.v1.BillPayAvailabilityResponse.Access",
                        "id": 1
                      }
                    },
                    "nested": {
                      "Access": {
                        "fields": {
                          "title": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "detail": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "viewLogEvent": {
                            "type": ".squareup.bbfrontend.service.v1.LogEvent",
                            "id": 3,
                            "rule": "optional"
                          },
                          "clickLogEvent": {
                            "type": ".squareup.bbfrontend.service.v1.LogEvent",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "result": {
                        "oneof": ["access"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse?.nested?.BillPayData && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse?.nested?.BillPayData?.nested?.PrivateCardData && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse?.nested?.BillPayData?.nested?.PrivateDirectDepositAccountData && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse?.nested?.Error && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataConfigurationResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataConfigurationResponse?.nested?.TwoFactorConfirmation && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataConfigurationResponse?.nested?.TwoFactorConfirmation?.nested?.CodeInput && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataConfigurationResponse?.nested?.BillPayDataConfiguration && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataConfigurationResponse?.nested?.BillPayDataConfiguration?.nested?.CardsSection && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataConfigurationResponse?.nested?.BillPayDataConfiguration?.nested?.CardsSection?.nested?.CardOption && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataConfigurationResponse?.nested?.BillPayDataConfiguration?.nested?.AccountsSection && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataConfigurationResponse?.nested?.BillPayDataConfiguration?.nested?.AccountsSection?.nested?.Account && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataConfigurationResponse?.nested?.BillPayDataConfiguration?.nested?.AccountsSection?.nested?.Account?.nested?.Value && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataConfigurationResponse?.nested?.BillPayDataConfiguration?.nested?.AccountsSection?.nested?.AccountsSectionLogEvents && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataConfigurationResponse?.nested?.Error && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BillPayAvailabilityRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BillPayAvailabilityResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BillPayAvailabilityResponse?.nested?.Access) {
  $root.addJSON(jsonData);
}

/**
 * GetBillPayData
 *
 * SOURCE GetBillPayDataRequest @ squareup/bbfrontend/v1/bill_pay.proto at 18:1
 */
export const GetBillPayDataRequest = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataRequest');
fixType(GetBillPayDataRequest, {
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillPayDataRequest);
/**
 * SOURCE GetBillPayDataResponse @ squareup/bbfrontend/v1/bill_pay.proto at 25:1
 */
export const GetBillPayDataResponse = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataResponse');
fixType(GetBillPayDataResponse);
Builder.createAndAttachToType(GetBillPayDataResponse);
/**
 * SOURCE BillPayData @ squareup/bbfrontend/v1/bill_pay.proto at 31:3
 */
GetBillPayDataResponse.BillPayData = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData');
fixType(GetBillPayDataResponse.BillPayData);
Builder.createAndAttachToType(GetBillPayDataResponse.BillPayData);
/**
 * duplicated from squareup.bizbank.card_management.PrivateCardData
 *
 * SOURCE PrivateCardData @ squareup/bbfrontend/v1/bill_pay.proto at 36:5
 */
GetBillPayDataResponse.BillPayData.PrivateCardData = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData.PrivateCardData');
fixType(GetBillPayDataResponse.BillPayData.PrivateCardData);
Builder.createAndAttachToType(GetBillPayDataResponse.BillPayData.PrivateCardData);
/**
 * SOURCE PrivateDirectDepositAccountData @ squareup/bbfrontend/v1/bill_pay.proto at 43:5
 */
GetBillPayDataResponse.BillPayData.PrivateDirectDepositAccountData = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData.PrivateDirectDepositAccountData');
fixType(GetBillPayDataResponse.BillPayData.PrivateDirectDepositAccountData);
Builder.createAndAttachToType(GetBillPayDataResponse.BillPayData.PrivateDirectDepositAccountData);
/**
 * SOURCE Error @ squareup/bbfrontend/v1/bill_pay.proto at 49:3
 */
GetBillPayDataResponse.Error = $root.lookupEnum('squareup.bbfrontend.service.v1.GetBillPayDataResponse.Error').values;
/**
 * SOURCE GetBillPayDataConfigurationResponse @ squareup/bbfrontend/v1/bill_pay.proto at 56:1
 */
export const GetBillPayDataConfigurationResponse = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse');
fixType(GetBillPayDataConfigurationResponse);
Builder.createAndAttachToType(GetBillPayDataConfigurationResponse);
/**
 * Session is not currently authorized so we need to 2FA with bizbank token.
 *
 * SOURCE TwoFactorConfirmation @ squareup/bbfrontend/v1/bill_pay.proto at 64:3
 */
GetBillPayDataConfigurationResponse.TwoFactorConfirmation = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.TwoFactorConfirmation');
fixType(GetBillPayDataConfigurationResponse.TwoFactorConfirmation, {
  header: {
    required: true
  },
  codeInput: {
    required: true
  },
  continueButtonText: {
    notEmpty: true
  },
  resendCodeText: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBillPayDataConfigurationResponse.TwoFactorConfirmation);
/**
 * SOURCE CodeInput @ squareup/bbfrontend/v1/bill_pay.proto at 70:5
 */
GetBillPayDataConfigurationResponse.TwoFactorConfirmation.CodeInput = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.TwoFactorConfirmation.CodeInput');
fixType(GetBillPayDataConfigurationResponse.TwoFactorConfirmation.CodeInput, {
  label: {
    notEmpty: true
  },
  codeLength: {
    required: true
  },
  placeholder: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBillPayDataConfigurationResponse.TwoFactorConfirmation.CodeInput);
/**
 * SOURCE BillPayDataConfiguration @ squareup/bbfrontend/v1/bill_pay.proto at 79:3
 */
GetBillPayDataConfigurationResponse.BillPayDataConfiguration = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration');
fixType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration, {
  header: {
    required: true
  },
  copyButtonText: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration);
/**
 * SOURCE CardsSection @ squareup/bbfrontend/v1/bill_pay.proto at 86:5
 */
GetBillPayDataConfigurationResponse.BillPayDataConfiguration.CardsSection = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration.CardsSection');
fixType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration.CardsSection, {
  title: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration.CardsSection);
/**
 * SOURCE CardOption @ squareup/bbfrontend/v1/bill_pay.proto at 91:7
 */
GetBillPayDataConfigurationResponse.BillPayDataConfiguration.CardsSection.CardOption = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration.CardsSection.CardOption');
fixType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration.CardsSection.CardOption, {
  id: {
    notEmpty: true
  },
  name: {
    notEmpty: true
  },
  card: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration.CardsSection.CardOption);
/**
 * SOURCE AccountsSection @ squareup/bbfrontend/v1/bill_pay.proto at 98:5
 */
GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection');
fixType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection, {
  title: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection);
/**
 * SOURCE Account @ squareup/bbfrontend/v1/bill_pay.proto at 103:7
 */
GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.Account = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.Account');
fixType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.Account, {
  id: {
    notEmpty: true
  },
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.Account);
/**
 * Used to represent an identifier or number associated with an account.
 * e.g. routing number, account number.
 *
 * SOURCE Value @ squareup/bbfrontend/v1/bill_pay.proto at 112:9
 */
GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.Account.Value = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.Account.Value');
fixType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.Account.Value, {
  label: {
    notEmpty: true
  },
  number: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.Account.Value);
/**
 * SOURCE AccountsSectionLogEvents @ squareup/bbfrontend/v1/bill_pay.proto at 119:7
 */
GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.AccountsSectionLogEvents = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.AccountsSectionLogEvents');
fixType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.AccountsSectionLogEvents, {
  expandLogEvent: {
    required: true
  },
  collapseLogEvent: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillPayDataConfigurationResponse.BillPayDataConfiguration.AccountsSection.AccountsSectionLogEvents);
/**
 * SOURCE Error @ squareup/bbfrontend/v1/bill_pay.proto at 126:3
 */
GetBillPayDataConfigurationResponse.Error = $root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse.Error');
fixType(GetBillPayDataConfigurationResponse.Error, {
  title: {
    notEmpty: true
  },
  subtitle: {
    notEmpty: true
  },
  buttonText: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBillPayDataConfigurationResponse.Error);
/**
 * Whether or not to show the Bill Pay entry point.
 *
 * SOURCE BillPayAvailabilityRequest @ squareup/bbfrontend/v1/bill_pay.proto at 136:1
 */
export const BillPayAvailabilityRequest = $root.lookupType('squareup.bbfrontend.service.v1.BillPayAvailabilityRequest');
fixType(BillPayAvailabilityRequest, {
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(BillPayAvailabilityRequest);
/**
 * SOURCE BillPayAvailabilityResponse @ squareup/bbfrontend/v1/bill_pay.proto at 140:1
 */
export const BillPayAvailabilityResponse = $root.lookupType('squareup.bbfrontend.service.v1.BillPayAvailabilityResponse');
fixType(BillPayAvailabilityResponse);
Builder.createAndAttachToType(BillPayAvailabilityResponse);
/**
 * SOURCE Access @ squareup/bbfrontend/v1/bill_pay.proto at 145:3
 */
BillPayAvailabilityResponse.Access = $root.lookupType('squareup.bbfrontend.service.v1.BillPayAvailabilityResponse.Access');
fixType(BillPayAvailabilityResponse.Access, {
  title: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BillPayAvailabilityResponse.Access);